const KEYWORDS = [
  "as",
  "bundle",
  "by",
  "default",
  "download",
  "except",
  "false",
  "for",
  "from",
  "having",
  "in",
  "inner",
  "is",
  "join",
  "left",
  "like",
  "literal",
  "not",
  "null",
  "nullable",
  "on",
  "outer",
  "regex",
  "right",
  "rows",
  "schema",
  "select",
  "table",
  "to",
  "true",
  "union",
  "unique",
  "upload",
  "upsert",
  "using",
  "where",
  "with",
];

const TYPES = ["string", "json", "date", "integer"];

const DOWNLOAD_SNIPPET = "download ${1:download_name} from { \n \n} using { \n \n};";
const UPLOAD_SNIPPET = "upload ${1:upload_name} to { \n \n};";
const TABLE_SNIPPET = "table ${1:table_t1} is select \n \nfrom ${2:table_t0};";
const SIMPLE_RECIPE_SNIPPET =
  "download ${1:download_name} from { \n\
    \n \n\
  } using {\n \n \n};\
  \n \n\
  table ${2:table_name} is select \n\
  \n \n\
  from ${1:download_name}; \
  \n \n\
  upload ${3:upload_name} to {\n \n \n};";
export { DOWNLOAD_SNIPPET, KEYWORDS, SIMPLE_RECIPE_SNIPPET, TABLE_SNIPPET, TYPES, UPLOAD_SNIPPET };
